/**
 * relationshipSegments — pure builder turning RelationshipLines (ids + key) into
 * drawable world-space segments between element centers, colored per relation
 * key. Mirrors the editor's SVG overlay (useRelationshipOverlay) but emits plain
 * geometry the canvas can stroke, with no dependency on a JointJS paper.
 */

import type { RelationshipLine } from '../../../map-editor-pages/editor/lib/relationshipCollect'
import { colorForRelationKey } from '../../../map-editor-pages/editor/lib/relationshipColor'

export interface RelationshipSegment {
  x1: number
  y1: number
  x2: number
  y2: number
  color: string
  bidirectional: boolean
}

export interface Center {
  x: number
  y: number
}

/**
 * Build segments between the centers of related elements. Lines whose source or
 * target center is missing (orphaned id) are skipped.
 */
export function buildRelationshipSegments(
  lines: readonly RelationshipLine[],
  centerById: ReadonlyMap<string, Center>
): RelationshipSegment[] {
  const segments: RelationshipSegment[] = []
  for (const line of lines) {
    const src = centerById.get(line.sourceId)
    const dst = centerById.get(line.targetId)
    if (!src || !dst) continue
    segments.push({
      x1: src.x,
      y1: src.y,
      x2: dst.x,
      y2: dst.y,
      color: colorForRelationKey(line.relationKey),
      bidirectional: line.bidirectional,
    })
  }
  return segments
}
